import { render, staticRenderFns } from "./AccordionProductCode.vue?vue&type=template&id=6b209370&"
import script from "./AccordionProductCode.vue?vue&type=script&lang=js&"
export * from "./AccordionProductCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports